import { NgModule } from '@angular/core';
import { FiMatIconCheckboxMenuComponent } from './fi-mat-icon-checkbox-menu.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiMatIconCheckboxMenuItemComponent } from '@fi-shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu-item/fi-mat-icon-checkbox-menu-item.component';

@NgModule({
    imports: [CommonModule, MatButtonModule, MatMenuModule, MatIconModule, MatCheckboxModule, InfoIconModule],
    declarations: [FiMatIconCheckboxMenuComponent, FiMatIconCheckboxMenuItemComponent],
    exports: [FiMatIconCheckboxMenuComponent],
})
export class FiMatIconCheckboxMenuModule {}
